module.exports = __webpack_public_path__ + "img/aboutUsHomeCart1.03a7436e.png";